import { ECOM_APP_DEF_ID, ECOM_CART_SECTION_ID } from '../const';
export async function isCartEnabled(wixCodeApi, businessInfo) {
  if (businessInfo.isCartEnabled) {
    return wixCodeApi.site.isAppSectionInstalled({
      sectionId: ECOM_CART_SECTION_ID,
      appDefinitionId: ECOM_APP_DEF_ID
    });
  }
  return false;
}
//# sourceMappingURL=isCartEnabled.js.map